import React from 'react';
import { motion } from 'framer-motion';

const LoadingScreen = ({ message = 'Loading your experience...' }) => {
  return (
    <div className="fixed inset-0 overflow-hidden bg-[#0A0F1A]">
      {/* Animated gradient background with depth - matching LandingPage */}
      <div 
        className="absolute inset-0"
        style={{
          background: `
            radial-gradient(circle at 80% 20%, rgba(68, 194, 253, 0.12) 0%, transparent 50%),
            radial-gradient(circle at 20% 80%, rgba(35, 166, 213, 0.08) 0%, transparent 50%),
            radial-gradient(circle at 50% 50%, rgba(68, 194, 253, 0.03) 0%, transparent 70%),
            linear-gradient(180deg, #0A0F1A 0%, #1C2837 100%)
          `,
        }}
      />
      
      {/* Animated mesh gradient overlay */}
      <div 
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage: `
            repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(68, 194, 253, 0.03) 2px, rgba(68, 194, 253, 0.03) 4px),
            repeating-linear-gradient(90deg, transparent, transparent 2px, rgba(68, 194, 253, 0.03) 2px, rgba(68, 194, 253, 0.03) 4px)
          `,
          backgroundSize: '100px 100px',
          animation: 'meshMove 20s linear infinite',
        }}
      />

      <style>{`
        @keyframes meshMove {
          0% { transform: translate(0, 0); }
          100% { transform: translate(100px, 100px); }
        }
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
        @keyframes glow {
          0%, 100% { opacity: 0.5; }
          50% { opacity: 0.8; }
        }
        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.05); opacity: 0.8; }
        }
      `}</style>

      {/* Main content container - centered */}
      <div className="relative h-full flex items-center justify-center px-8">
        <div className="text-center">
          {/* Labb Logo with glow effect */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
            className="flex justify-center mb-12 relative"
          >
            <div className="absolute inset-0 blur-2xl bg-[#44C2FD] opacity-20 animate-[glow_4s_ease-in-out_infinite]" />
            <img 
              src="/images/cara-white.png" 
              alt="Cara Logo" 
              className="h-64 relative z-10 drop-shadow-2xl animate-[pulse_3s_ease-in-out_infinite]"
              style={{ filter: 'brightness(1.15) drop-shadow(0 0 20px rgba(68, 194, 253, 0.5))' }}
            />
          </motion.div>

          {/* Spinner */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="flex justify-center mb-8"
          >
            <div 
              className="relative"
              style={{
                width: '80px',
                height: '80px',
              }}
            >
              {/* Outer ring */}
              <div
                className="absolute inset-0 rounded-full"
                style={{
                  border: '4px solid rgba(68, 194, 253, 0.1)',
                }}
              />
              {/* Spinning ring */}
              <div
                className="absolute inset-0 rounded-full"
                style={{
                  border: '4px solid transparent',
                  borderTopColor: '#44C2FD',
                  borderRightColor: '#44C2FD',
                  animation: 'spin 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite',
                  boxShadow: '0 0 20px rgba(68, 194, 253, 0.4)',
                }}
              />
              {/* Inner glow */}
              <div
                className="absolute inset-2 rounded-full bg-[#44C2FD] opacity-10 animate-[pulse_2s_ease-in-out_infinite]"
              />
            </div>
          </motion.div>

          {/* Loading message */}
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
            className="text-white text-lg font-light tracking-wide"
            style={{
              fontFamily: 'Lato, -apple-system, BlinkMacSystemFont, sans-serif',
              textShadow: '0 2px 20px rgba(68, 194, 253, 0.2)',
            }}
          >
            {message}
          </motion.p>
          
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
